import React from 'react';
import useAuth from '../hooks/useAuth';
import StaffDocumentsTab from './StaffDocumentsTab';

export default function MyDocuments() {
  const { auth } = useAuth();

  return (
    <div style={{ padding: 16, maxWidth: 900, margin: '0 auto' }}>
      <h2 style={{ marginBottom: 16 }}>My Documents</h2>
      <p style={{ color: '#6b7280', marginBottom: 16, fontSize: 13 }}>
        Upload your KYC, payroll, and other documents here. All files are encrypted and stored securely.
      </p>
      <StaffDocumentsTab username={auth?.username} />
    </div>
  );
}
